import React, { useRef, useState, useCallback, useEffect } from 'react'
import hash from 'object-hash'

import {
  PasswordRequestWrapper,
  PasswordRequestLogo,
  PasswordRequestInput,
  PasswordRequestButton
} from './index.styled'

const LayoutPasswordRequest = ({ password, onLoginSuccess }) => {
  const [error, setError] = useState(false)
  const inputRef = useRef()

  const login = useCallback(() => {
    console.log('Logging in', inputRef.current.value)
    if (password === hash.sha1(inputRef.current.value)) {
      setError(false)
      try {
        sessionStorage.setItem('accessPass', inputRef.current.value)
      } catch (error) {
        console.warn('No access to sessionStorage')
      }
      onLoginSuccess && onLoginSuccess(true)
    } else {
      setError(true)
    }
  }, [password, onLoginSuccess, inputRef])

  useEffect(() => {
    try {
      const savedPass = sessionStorage.getItem('accessPass')
      if (savedPass && hash.sha1(savedPass) === password) {
        onLoginSuccess(true)
      }
    } catch (error) {
      console.warn('No access to sessionStorage')
    }
  }, [password, onLoginSuccess])

  return (
    <PasswordRequestWrapper>
      <PasswordRequestLogo />
      <PasswordRequestInput ref={inputRef} placeholder='PASSWORD' type='password' className={error && 'error'} />
      <PasswordRequestButton onClick={login}>LOG IN</PasswordRequestButton>
    </PasswordRequestWrapper>
  )
}

export default LayoutPasswordRequest
